import { FunctionComponent, useEffect, useState } from "react";
import {
  mdiArrowTopRight,
  mdiClose,
  mdiCommentBookmark,
  mdiHistory,
  mdiRefresh,
} from "@mdi/js";
import { Icon } from "@mdi/react";
import ModalDialog from "../../new_components/common/modal";
import { GetInventoryListApi } from "../../../service/repos/inventory_repo";
import { InventoryModel } from "../../../service/models/inventory/inventory_model";
import { InventoryStatus } from "../../../utils/enums";
import Pagination from "../../new_components/common/pagination";
import LoadingWidget from "../../components/loading_spinner";
import moment from "moment";
import { NavLink } from "react-router-dom";
import SearchFieldWidget from "../../new_components/search_field";
import FilterDropDown from "../../new_components/common/filter_drop_down";
import { WarehouseModel } from "../../../service/models/inventory/warehouse_model";
import ExportInventory from "./components/export_widget";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../new_components/common/drawer_modal";
import HistoryWidget from "./components/history_widget";
import CommentWidget from "./components/comment_widget";
import { GetProductsApi } from "../../../service/repos/products_repo";
import ProductModel from "../../../service/models/product_model";
import {
  ToastType,
  useToast,
} from "../../../context_providers/toast/toast_ctx";
import EmployeeSearchWidget from "../../new_components/emp_search_widget";
import { UserModel } from "../../../context_providers/auth/user_model";
import { GetWareHouseListApi } from "../../../erp/inventory/inventory_basket/components/warehouse_repo";
interface OldInventoryListingProps {}

interface FilterData {
  product_id?: string[];
  status?: string[];
  search?: string;
  page: number;
  count: number;
  all?: any;
  warehouse_id?: string[];
  fromDate?: Date;
  toDate?: Date;
  responsible_id?: string;
  responsible_name?: string;
}

const defaultFilter: FilterData = {
  page: 1,
  count: 100,
};
const OldInventoryListing: FunctionComponent<OldInventoryListingProps> = () => {
  const { showToast } = useToast();
  const [filter, setFilter] = useState<FilterData>(defaultFilter);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [inventories, setInventories] = useState<InventoryModel[]>([]);
  const [warehouses, setWarehouses] = useState<WarehouseModel[]>([]);
  const [showExport, setShowExport] = useState(false);
  const [showHistory, setShowHistory] = useState(0);
  const [showComment, setShowComment] = useState(0);
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState<ProductModel[]>([]);

  const getProducts = async () => {
    const res = await GetProductsApi();
    if (res.success) {
      setProducts(res.data);
    }
  };

  const getWarehouses = async () => {
    const res = await GetWareHouseListApi({ page: 0, all: true, count: 0 });
    console.log({ res });

    if (res.success) {
      setWarehouses(res.data.data!);
    }
  };

  useEffect(() => {
    getWarehouses();
    getProducts();
  }, []);

  useEffect(() => {
    getInventories();
  }, [filter, search]);

  const getInventories = async () => {
    setLoading(true);

    const res = await GetInventoryListApi(
      search ? { page: 1, search, count: 0, all: true } : filter
    );

    if (res.success) {
      setInventories(res.data.inventories);
      if (res.data.metadata[0]) setTotal(res.data.metadata[0].total);
      // }
    } else {
      showToast({ type: ToastType.error, text: res.error ?? "" });
    }
    setLoading(false);
  };

  return (
    <>
      {showHistory !== 0 && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={showHistory !== 0}
          onClose={() => setShowHistory(0)}
          title="History"
        >
          <HistoryWidget inventory_id={showHistory} />
        </DrawerModal>
      )}
      {showComment !== 0 && (
        <DrawerModal
          onClose={() => setShowComment(0)}
          title="Note"
          show={showComment !== 0}
          location={DrawerModalLoaction.right}
        >
          <CommentWidget inventory_id={showComment} />
        </DrawerModal>
      )}
      {showExport && (
        <ModalDialog
          show={showExport}
          title="Export"
          onClose={() => setShowExport(false)}
        >
          <ExportInventory filter={filter} />
        </ModalDialog>
      )}

      <div className={`px-3 py-5 h-screen  `}>
        <div className="flex flex-wrap justify-between items-end my-3 text-sm">
          <h1 className="font-bold text-2xl text-gray-500 flex items-center gap-3">
            Previous Device Inventory
            <button onClick={() => getInventories()}>
              <Icon path={mdiRefresh} className="h-6 w-6"></Icon>
            </button>
          </h1>
          <div className="flex flex-wrap gap-2  ">
            <SearchFieldWidget
              defaulValue={search}
              onSubmit={(s) => setSearch(s)}
              onClear={() => setSearch("")}
            />
            <button
              onClick={() => setShowExport(true)}
              className="rounded-lg border px-2 py-1 hover:bg-gray-800 hover:text-white flex gap-2 items-center"
            >
              <Icon path={mdiArrowTopRight} size="15"></Icon> Export
            </button>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 justify-between items-end">
          <div className="flex gap-2 text-sm"></div>
          <div className="flex flex-wrap gap-2">
            <FilterDropDown
              selectedOptions={filter.status}
              placeholder="Status"
              onSelect={function (val: any): void {
                setFilter((old) => ({
                  ...old,
                  status: [...(old.status ?? []), val],
                }));
              }}
              onClearAll={function (): void {
                setFilter((old) => ({ ...old, status: undefined }));
              }}
              onDelete={function (val: any): void {
                setFilter((old) => ({
                  ...old,
                  status: old.status?.filter((v) => v !== val),
                }));
              }}
              options={Object.values(InventoryStatus).map((s) => ({
                label: s,
                value: s,
              }))}
            />
            <FilterDropDown
              selectedOptions={filter.product_id}
              placeholder="Product"
              onSelect={function (val: any): void {
                setFilter((old) => ({
                  ...old,
                  product_id: [...(old.product_id ?? []), val],
                }));
              }}
              onClearAll={function (): void {
                setFilter((old) => ({ ...old, product_id: undefined }));
              }}
              onDelete={function (val: any): void {
                setFilter((old) => ({
                  ...old,
                  product_id: old.product_id?.filter((v) => v !== val),
                }));
              }}
              options={products.map((p) => ({
                label: p.name,
                value: p.id,
              }))}
            />
            <FilterDropDown
              selectedOptions={filter.warehouse_id}
              placeholder="Warehouse"
              onSelect={function (val: any): void {
                setFilter((old) => ({
                  ...old,
                  warehouse_id: [...(old.warehouse_id ?? []), val],
                }));
              }}
              onClearAll={function (): void {
                setFilter((old) => ({ ...old, warehouse_id: undefined }));
              }}
              onDelete={function (val: any): void {
                setFilter((old) => ({
                  ...old,
                  warehouse_id: old.warehouse_id?.filter((v) => v !== val),
                }));
              }}
              options={warehouses.map((w) => ({
                label: w.name,
                value: w.id,
              }))}
            />
            <div className="w-52 grid grid-cols-8  ">
              <div className="col-span-6">
                <EmployeeSearchWidget
                  withBtn={false}
                  emp={
                    filter.responsible_id && filter.responsible_name
                      ? {
                          uid: filter.responsible_id!,
                          name: filter.responsible_name!,
                        }
                      : undefined
                  }
                  onSelect={function (d: UserModel): void {
                    setFilter((o) => ({
                      ...o,
                      responsible_id: d.uid,
                      responsible_name: d.first_name + " " + d.last_name,
                    }));
                  }}
                />
              </div>
              <div className="col-span-2  text-xs flex justify-center items-center">
                <button
                  className={`${
                    (!filter.responsible_id || !filter.responsible_name) &&
                    "cursor-not-allowed text-gray-400"
                  }`}
                  disabled={!filter.responsible_id || !filter.responsible_name}
                  onClick={() =>
                    setFilter((o) => ({
                      ...o,
                      responsible_id: undefined,
                      responsible_name: undefined,
                    }))
                  }
                >
                  <Icon path={mdiClose} size={0.8} />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="my-2 border overflow-auto" style={{ height: "80%" }}>
          <table className="w-full     text-xs divide-y divide-gray-200 relative ">
            <thead className="  text-xs   py-2 sticky -top-1 bg-white z-10">
              <tr className="border ">
                <th className="px-2 py-2"></th>
                <th className="px-2 py-2">Created on</th>
                <th className="px-2 py-2">Device ID</th>
                <th className="px-2 py-2">Org namespace</th>
                <th>Product</th>
                <th>Warehouse</th>
                <th>Status</th>
                <th>Responsible</th>
                <th>Order Id</th>
              </tr>
            </thead>
            <tbody className="">
              {inventories.length > 0 ? (
                inventories.map((d, i) => {
                  const allotment = d.allocations.find((od) =>
                    [
                      InventoryStatus.installed,
                      InventoryStatus.delivered,
                    ].includes(od.status)
                  );

                  return (
                    <tr className="border text-center " key={i}>
                      <td>
                        <div className="flex gap-2 justify-center">
                          <div
                            className="cursor-pointer"
                            onClick={() => setShowComment(d.id)}
                          >
                            <Icon path={mdiCommentBookmark} size="16"></Icon>
                          </div>
                          <div
                            className="cursor-pointer"
                            onClick={() => setShowHistory(d.id)}
                          >
                            <Icon path={mdiHistory} size="16"></Icon>
                          </div>
                        </div>
                      </td>
                      <td className="px-3 py-2">
                        {moment(d.created_at).format("DD MMM YYYY")}
                      </td>
                      <td className="px-3 py-2  ">{d.device_id}</td>
                      <td className="px-3 py-2">
                        {allotment?.org_namespace ?? "--"}
                      </td>
                      <td className="px-3 py-2">{d.device.product_name}</td>
                      <td className="px-3 py-2">
                        {d.warehouse?.name || "---"}
                      </td>
                      <td className="px-3 py-2">{d.status}</td>
                      <td className="px-3 py-2">
                        {d.responsible_name || "--"}
                      </td>
                      <td className="px-3 py-2">
                        {" "}
                        {allotment?.order_id ? (
                          <NavLink
                            className=" text-purple-500"
                            target="_blank"
                            to={"/orders/" + allotment?.order_id + "/devices"}
                          >
                            {allotment?.order_id}
                          </NavLink>
                        ) : (
                          <>N/A</>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={13}>
                    <div className="h-56 text-center p-5 my-20">
                      <h5 className="text-gray-400 text-2xl">No Data found!</h5>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="mt-3">
          <Pagination
            itemCount={inventories.length}
            page={filter.page}
            total={total}
            count={filter.count}
            onChange={(page) => setFilter((o) => ({ ...o, page }))}
          />
        </div>

        <LoadingWidget loading={loading} />
      </div>
    </>
  );
};

export default OldInventoryListing;
